var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterAdjusted = function SvgFilterAdjusted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.258 5.59H3.75a.95.95 0 0 0-.704.29.972.972 0 0 0-.286.71c0 .28.095.516.286.707.19.192.426.288.704.288h12.764a5 5 0 0 1-1.256-1.995m-5.212 12.518c.19.192.426.288.704.288h2.5a.962.962 0 0 0 .704-.284.948.948 0 0 0 .286-.702.963.963 0 0 0-.286-.707.955.955 0 0 0-.704-.288h-2.5a.962.962 0 0 0-.704.283.949.949 0 0 0-.286.703c0 .28.095.515.286.707m-4-5.405c.19.191.426.287.704.287h10.5a.962.962 0 0 0 .704-.283.949.949 0 0 0 .286-.703.963.963 0 0 0-.286-.707.955.955 0 0 0-.704-.287H6.75a.963.963 0 0 0-.704.283.949.949 0 0 0-.286.703c0 .28.095.515.286.707",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 17,
    y: 1,
    fill: "currentColor",
    className: "filter-adjusted_svg__adjustment-indicator",
    rx: 3
  })));
};
export default SvgFilterAdjusted;